import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { concat } from 'lodash';
import SearchPage from './page';
import {
    ONE_Z_SEARCH,
    ONE_Z_SEARCH_PWA,
    SHOW_FACETED_SEARCHBAR,
    PINA_HAMBURGER_MENU_WELL_GUIDE_LINK,
    SPO_USE_SPOOM,
    PCE_TRACKING_ID_DUMMY,
} from '../../config/ab/experiments';
import { withAB } from '../../config/ab';

const experimentsDefault = [
    PCE_TRACKING_ID_DUMMY,
    SPO_USE_SPOOM,
];

const experiments1Z = [
    ONE_Z_SEARCH,
    ONE_Z_SEARCH_PWA,
    PINA_HAMBURGER_MENU_WELL_GUIDE_LINK,
    SHOW_FACETED_SEARCHBAR,
];

// TODO: refactor. This array is side-effecty and was implemented as temporary solution for conditional experiments.
let experiments = [];

const SearchPageWithAB = withAB(() => experiments)(SearchPage);

export default class SearchPageContainer extends Component {
    static propTypes = {
        is1Z: PropTypes.bool.isRequired,
    };

    render() {
        const {
            is1Z,
            ...props
        } = this.props;

        experiments = concat(
            experimentsDefault,
            is1Z ? experiments1Z : [],
        );

        return (
            <SearchPageWithAB {...props} />
        );
    }
}
